export default __webpack_public_path__ + "static/media/icons-social-media-youtube.730ea0fb.png";